import { gql } from '@/__generated__';
import { makeSsrApolloClient } from '@/apollo/ssr-apollo-client';
import { mentionsBlockedTerm } from '../sitemap[.]xml/blocked-terms';
import { SeoHandle } from '../sitemap[.]xml/generate-sitemap';

const PublicStreamsQuery = gql(`
  query PublicStreams($limit: Int, $nextToken: String) {
    streamsAll(limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        slug
      }
      nextToken
    }
  }`);

export const streamSitemap: SeoHandle['sitemap'] = async () => {
  const client = makeSsrApolloClient();

  let nextToken;
  const allItems: { id: string; name: string; slug: string }[] = [];

  do {
    const { data, error } = await client.query({
      query: PublicStreamsQuery,
      variables: { limit: 1000, nextToken: null },
    });

    if (error) {
      throw error;
    }

    allItems.push(...data.streamsAll.items);
    nextToken = data.streamsAll.nextToken;
  } while (nextToken);

  const visibleItems = allItems.filter(
    ({ name, slug }) => !mentionsBlockedTerm(name, slug),
  );

  return visibleItems
    .map(({ slug }) => ({
      path: `p/streams/${slug}`,
    }))
    .concat(
      visibleItems.map(({ id }) => ({
        path: `p/streams/${id}`,
      })),
    );
};
